import React from 'react';
import { Link } from 'react-router-dom';
import './CareersPage.css';

function CareersPage() {
  const bannerStyle = {
    backgroundImage: `url(/assets/NeXusNeuroClinical_mit.webp)`,
  };

  return (
    <main className="careers-page">
      <section className="careers-banner" style={bannerStyle}>
        <div className="careers-banner-overlay">
          <Link to="/" className="careers-back">&larr; Home</Link>
          <img
            src="/assets/nexus_neuro_logo.webp"
            alt="NeXus NeuroInformatics, Inc."
            className="careers-banner-logo"
          />
          <h1 className="careers-banner-title">Careers</h1>
        </div>
      </section>

      <header className="careers-header">
        <p className="careers-deck">
          We are small, careful, and growing in deliberate steps. We are not
          running a public hiring cycle right now, but we keep an open line for
          the people whose work might one day fit ours.
        </p>
      </header>

      <section className="careers-body">

        <article className="careers-section">
          <span className="careers-label">Where We Are</span>
          <h2 className="careers-h2">A small, intentional team</h2>
          <p>
            NeXus NeuroInformatics is in the foundational stage of its lifecycle.
            Our current focus is building the scientific foundation, generating
            evidence, and establishing the regulatory and research partnerships
            necessary to evaluate whether biologically grounded AI simulations
            can contribute meaningfully to future biomedical research workflows.
          </p>
          <p>
            That work today is being done by a Board of Directors, a scientific
            advisor, and the founder. You can{' '}
            <Link to="/team">meet us here</Link>.
          </p>
        </article>

        <article className="careers-section">
          <span className="careers-label">Who We&rsquo;d Hear From</span>
          <h2 className="careers-h2">Backgrounds we keep an eye on</h2>
          <p>
            If your work sits at any of the following intersections, we welcome
            an introductory note even when no role is posted. We file these for
            when the right moment arrives.
          </p>
          <ul className="careers-list">
            <li>
              <strong>Biochemistry and molecular biology</strong>{' '}
              with comfort in pharmacokinetic and pharmacodynamic modeling.
            </li>
            <li>
              <strong>Regulatory affairs</strong> with experience in FDA
              digital-health pathways, IEC 62304, 21 CFR 820.30 design controls,
              or AI-SaMD precedent.
            </li>
            <li>
              <strong>ML and systems engineering</strong> with interest in
              auditable, verification-gated AI systems and biology-native
              compiled languages.
            </li>
            <li>
              <strong>Clinical and translational research</strong> with insight
              into where mechanistic <em>in silico</em> simulation could
              meaningfully assist pre-clinical hypothesis exploration.
            </li>
            <li>
              <strong>Quality and laboratory operations</strong> with experience
              defending dataset selection and reproducibility discipline in
              regulated environments.
            </li>
          </ul>
        </article>

        <article className="careers-section">
          <span className="careers-label">How to Reach Us</span>
          <h2 className="careers-h2">An honest introduction goes a long way</h2>
          <p>
            We read every message that comes through the{' '}
            <Link to="/contact">Contact page</Link>. A brief note explaining
            what you do and why our work caught your attention is the most
            useful thing you can send. Attach a CV or portfolio if you have one,
            but the note matters more than the document.
          </p>
        </article>

      </section>
    </main>
  );
}

export default CareersPage;
